<template>
<div
	class="flex items-center justify-center p-2 font-semibold text-white rounded-full avatar bg-accent"
	:class="[`avatar--${size}`]"
	:style="style"
	data-component="Avatar.vue"
>
	<OIcon v-if="!image && !initials" name="avatar" :size="4"/>
	<template v-else-if="!image">
		{{ Format.AvatarLetters(initials) }}
	</template>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za wyświetlanie awatara użytkownika.
// @group Base Components
export default {
	name: 'BaseAvatar',
	props: {
		user: { type: Object, required: true },
		size: { type: String, default: 'lg' },
		hideImage: { type: Boolean, default: false },
	},
	computed: {
		image() {
			if (this.hideImage) { return ''; }
			return this.user?.avatar || this.user?.Avatar || this.user?.path || '';
		},
		initials() {
			if (this.user?.userName && this.user?.userName.length > 0) {
				return this.user.userName;
			}
			return (this.user.firstName || this.user.FirstName)
				? `${(this.user.firstName || this.user.FirstName || '')} ${this.user.lastName || this.user.LastName || ''}`
				: '';
		},
		style() {
			return this.image
				? { 'background-image': `url(${this.image})` }
				: {
					'background-color': this.initials
						? this.Format.AvatarColor(this.initials)
						: '#eeeeee',
				};
		},
	},
};
</script>

<style lang="scss" scoped>
.avatar {
	background-position: center;
	background-size: cover;
	text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);

	&--xs {
		width: 24px;
		height: 24px;
		font-size: 10px;
	}

	&--sm {
		width: 36px;
		height: 36px;
		box-shadow: 0 0 1px black;
	}

	&--md {
		width: 60px;
		height: 60px;
		font-size: 24px;
		font-weight: 700;
	}

	&--lg {
		width: 100px;
		height: 100px;
		border: 8px solid #fff;
		font-size: 36px;
		font-weight: 800;
	}

	&--xl {
		width: 160px;
		height: 160px;
		border: 8px solid #fff;
		font-size: 60px;
		font-weight: 800;
	}

	&--5rem {
		width: 5rem;
		height: 5rem;
		border: 2px solid #fff;
		filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0.25px 1.5px 2px rgba(0, 0, 0, 0.08));
	}
}
</style>
